// import Header from '../components/Header'
import { atom, useAtom } from 'jotai'
import React from 'react';
// import { Link } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';
import { useState, useEffect, useRef } from 'react'
import axios from "axios";

import {Helmet} from "react-helmet";

import {isSmallAtom,priceAtom, messageAtom, productAtom, textAtom,titleAtom,audioFileAtom,isLandscapePopupAtom,isShowingHelpAtom,isContrastAtom} from '../atoms/atom.config.js'
import { mobileWidth,smallMobileWidth, SECTIONS, FEATURES, API, MEDIA } from '../constants';
import useDeviceSize from '../components/useDeviceSize';
import isMobileDevice from '../utils/is-mobile';

// assets
import logoImage from '../assets/images/default_thumb.jpg'
import scrollDownIcon from '../assets/icons/icon_scrolldown.svg'
import scrollerDotIcon from "../assets/icons/icon_dot_page.svg"
import scrollerDotActiveIcon from "../assets/icons/icon_dot_current_page.svg"
import creditsIcon from '../assets/icons/icon_credits.svg'
// preload options icons
import optionsIcon from '../assets/icons/icon_options.svg'
import optionsIconHover from'../assets/icons/icon_options_h.svg'
import closeOptionsIcon from '../assets/icons/icon_close_wht.svg'
import closeOptionsIconHover from '../assets/icons/icon_close_wht_h.svg'
import pauseIcon from '../assets/icons/icon_pause.svg'
import pauseIconOff from '../assets/icons/icon_pause_off.svg'
import pauseIconHover from'../assets/icons/icon_pause_h.svg'
import pauseIconHoverAlt from'../assets/icons/icon_pause_off_h.svg'
import contrastIcon from '../assets/icons/icon_contrast.svg'
import contrastIconOff from '../assets/icons/icon_contrast_off.svg'
import contrastIconHover from '../assets/icons/icon_contrast_h.svg'
import contrastIconHoverAlt from '../assets/icons/icon_contrast_alt_h.svg'
import soundIcon from '../assets/icons/icon_sound.svg'
import soundIconOff from '../assets/icons/icon_sound_off.svg'
import soundIconHover from '../assets/icons/icon_sound_h.svg'
import soundIconHoverAlt from '../assets/icons/icon_sound_off_alt_h.svg'
//preload logo icons
import logoIcon from '../assets/icons/logo_desktop.svg'
import logoIconHover from '../assets/icons/logo_desktop_h.svg'

// components
import SlideFull from '../components/Slides'
import {VideoBackground,VideoBackgroundFixed} from '../components/VideoBackground';
// import bgVideo from '../assets/videos/00_Introduction.mp4';
import {SlidesScroller} from '../components/SlidesScroller'
import {OutlineButtonTextIcon, ButtonTextIcon, ButtonTextIconWhiteHover} from '../components/Button'
import Spinner from '../components/Spinner'
import Footer from '../components/Footer'
import { ModalOverlay, ModalOverlaySmall } from "../components/ModalOverlay";
import { PreloadedImages } from '../components/PreloadedImages'

import parse from 'html-react-parser';

import inobounce from "inobounce"

// import { WavingFlag } from '@garvae/react-waving-flag/index.js';

import sound from '../assets/sounds/RBA_Banknote_Site_Soundscape.mp3' //RBA 220816.mp3'
import spinnerIcon from '../assets/icons/spinner_intro.svg'
// import spinnerIcon from '../assets/icons/spinner_bird5.svg'

//const About:React.FC = () => {
export default function Home() {
  //const [value, updateValue] = useAtom(anAtom)
  // const [text, setText] = useAtom(textAtom)
  const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  const [data, setData] = useState(null);
  const [progressIcons, setProgressIcons] = useState([])
  const [title, setTitle] = useAtom(titleAtom);
  const [creditsData, setCreditsData] = useState(null);  
  const [audioFile, setAudioFile] = useAtom(audioFileAtom); // "blah.mp3"
  // credits
  const [isCredits, setIsCredits] = useState(false);
  // const [isHelp, setIsHelp] = useState(false);
  const [isHelp, setIsHelp] = useAtom(isShowingHelpAtom);
  const [helpData, setHelpData] = useState(null);
  // landscape popup states: 0 (default- hasnt checked if landscape mobile yet), 1 (manually disabled- dont need to show again), 2 (show popup)
  const [isLandscapePopup, setIsLandscapePopup] = useAtom(isLandscapePopupAtom); //useState(true); 
  const [deviceWidth, deviceHeight] = useDeviceSize();

  const [isContrast, setIsContrast] = useAtom(isContrastAtom);

  // a custom copy of the slide index
  const [customSlideEventIndex, setCustomSlideEventIndex] = useState(0);

  const firstSlideRef = useRef(null);
  const slidesScrollerRef = useRef(null)

  //const [testIndex, setTestIndex] = useState(0);
  const testIndex = useRef(0);

  // preload the whole page including images + videos before displaying content
  const [isPreloading, setIsPreloading] = useState(true);
  //const [loadedCount, setLoadedCount] = useRef(0);
  const loadedCount = useRef(0)

  let _isMobile = null;

  // axios fetch
  const fetchData = async (url) => {
    try {
      //export const DOMAIN = 'https://beechworth.herokuapp.com/';
      //export const HEADERS = { headers: { 'Access-Control-Allow-Origin': DOMAIN } }
      const response = await axios.get(url); //, HEADERS);
      //setData(response.data.about);
      //setLogos(response.data.logos);
      console.log(response.data)
      if(response.data.length > 0) {
        //console.log(response.data)
        setData(response.data[0]);
      }

      const response3 = await axios.get(API.CREDITS); //, HEADERS);
      console.log(response3.data)
      setCreditsData(response3.data);

      const response4 = await axios.get(API.HELP); //, HEADERS);
      console.log(response4.data)
      if(response4.data.length > 0) {
        setHelpData(response4.data[0]);
      }
      
      
    } catch(error) {
      console.error(error);
    }
  };

  const handleTestEvent = event => {
    //console.log("handleScrollTest", isScrolling, event)
    console.log("handleTestEvent0", testIndex.current)
    testIndex.current = testIndex.current+1
    //setTestIndex(testIndex+1)
    console.log("handleTestEvent1", testIndex.current)
  }

  const updatePreloadCounter = (path) => {
    // if all assets loaded then toggle the preloader
    let count = loadedCount.current+1
    loadedCount.current = count;
    //setLoadedCount(count)
    console.log("updatePreloadCounter:",count, path)
    if(count >= 2 && isPreloading) {
      //console.log("PRELOAD COMPLETE!", count)
      //setIsPreloading(false)
      //setTimeout(() => {
        setIsPreloading(false)
        console.log("PRELOAD COMPLETE", count)
      //},3000);
    }
  };

  

  const onLandscapePopupCloseEvent = event => {
    console.log("onLandscapePopupCloseEvent (note)", event)
    setIsLandscapePopup(1)

    // re-enable body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(false, false)
    else {
      // if we are mobile we need to force the body scroll back OFF- as the library reenabled internally
      //toggleBodyScroll(true, true, true)
      setTimeout(() => {
        toggleBodyScroll(true, true)
      },10);
      //toggleBodyScroll(true, true)
    }
  }

  const onCreditsOpenEvent = (event) => {
    console.log("onCreditsOpenEvent (note)", event)
    setIsCredits(true)
    //toggleBodyScroll(true, true)

    // disable main body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(true, true)

  };

  const onCreditsCloseEvent = event => {
    console.log("onCreditsCloseEvent (note)", event)
    setIsCredits(false)
    //toggleBodyScroll(false, true)

    // re-enable body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(false, false)
    else {
      // if we are mobile we need to force the body scroll back OFF- as the library reenabled internally
      //toggleBodyScroll(true, true, true)
      setTimeout(() => {
        toggleBodyScroll(true, true)
      },10);
      //toggleBodyScroll(true, true)
    }
  };

  const getBackgroundCredits = (field, note="$") => {
    const credits = creditsData; //props.credits; 
    console.log(credits)
    if(credits) {
      for (let i = 0; i < credits.length; i++) {
        if(credits[i].note == note) {
          return parse(credits[i][field])
        }
      }
    }
    return "..."
  };

  // const getHelpDescription = (data) => {
  //   return parse(helpData.description)
  // };

  // custom help overlay (copy+paste into note.js+home.js as well)
  // - note this is just a global flag that is triggered via the nav in app.js. we need to 'listen' when it changes so we can add/remove the scroll listeners
  const onHelpOpenEvent = (event) => {
    console.log("onHelpOpenEvent (note)", event)
    //setIsHelp(true) // this is already flagged via app.js

    // disable main body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(true, true)

  };

  const onHelpClosed = (e) => {
    console.log("onHelpClosed",e)
    setIsHelp(false)

    // re-enable body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(false, false)
    else {
      // if we are mobile we need to force the body scroll back OFF- as the library reenabled internally
      //toggleBodyScroll(true, true, true)
      setTimeout(() => {
        toggleBodyScroll(true, true)
      },10);
      //toggleBodyScroll(true, true)
    }
  }

  // FIXME: toggling this forces the window scroll position to 0,0
  // it seems automatically managed correctly using the zoom, but the credist is NOT
  const toggleBodyScroll = (off, allowToggleBodyScroll=false) => {
    // if(on) {
    //   //document.body.classList.add("no-scroll")
    //   document.body.style.overflow = "hidden"
    // } else {
    //   document.body.style.overflow = "auto"
    // }
    console.log("home toggleBodyScroll OFF", off, slidesScrollerRef.current)
    const html = document.querySelector("html");
    if (html) {
      if(allowToggleBodyScroll) {
        //document.body.style.overflow = off ? "hidden" : "unset";
        //document.body.style.overflowY = off ? "hidden" : "unset";
        // FIXME: on ios the scroll is broken unless we add to the html
        html.style.overflow = off ? "hidden" : "unset";
        html.style.overflowY = off ? "hidden" : "unset";
      }
      //if(allowToggleBodyScroll) html.style.overflow = off ? "hidden" : "auto";
      if(slidesScrollerRef.current) {
        slidesScrollerRef.current.toggleScrollMod(off)
      }
      
    }
  };


  const onScroll = evt => {
    evt.preventDefault();
    console.log("onScroll", testIndex.current, evt)
  };

  const onSlidesScrollerSlideChanged = evt => {
    console.log("onSlidesScrollerSlideChanged", evt)
    setCustomSlideEventIndex(evt.detail)
  };

  /*const isSafariDevice = () => {
    return (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad' || navigator.platform === 'iPhone'
  };*/
  const isLandscapeMobile = () => {  
    // note- we dont want to use the isSmall breakpoint as it allows ipads and much larger resolutions- need a smaller breakpoint  
    if(deviceWidth > deviceHeight && isSmall && (deviceWidth < smallMobileWidth)) {
      console.log("isLandscapeMobile detected!", deviceWidth, deviceHeight, isSmall)
      return true
    }
    return false
  };

  useEffect(() => {
    console.log("init home: force scroll to 0,0")
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if(inobounce.isScrollSupported) {
      // ios only (android is disabling the div scroll)
      inobounce.enable();
    }
    _isMobile = isMobileDevice();

    setTitle(SECTIONS.INTRO )

    setAudioFile(sound);

    //console.log(fetchData('https://api.github.com/repos/vercel/swr'))
    //fetchData('https://api.github.com/repos/vercel/swr');
    console.log("fetching data...")
    fetchData(API.INTRO); // './introduction.json')
    

    const iconDefault = {icon:scrollerDotIcon,active:scrollerDotActiveIcon,size:8,alt:"Exploring the Next Generation of Banknotes"} //data.title
    const iconDefault2 = {icon:scrollerDotIcon,active:scrollerDotActiveIcon,size:8,alt:"Choose a banknote"}
    const icons = [iconDefault, iconDefault2]
    setProgressIcons(icons);


    
    // if(isSmall) {
    //   toggleBodyScroll(true, true)
    // } else {
    //   toggleBodyScroll(false)
    // }
    //document.addEventListener('wheel', onScroll, { passive: false });
  }, []);

  // if we toggle to small/mobile we need to disable body scroll
  useEffect(() => {
    console.log("isSmall changed (home):", isSmall)

    

    // FIXME: need to disable 'body/doc scroll' for mobile
    //toggleBodyScroll(true)
    //toggleBodyScroll(true, true)
    if(isSmall) {
      toggleBodyScroll(true, true)
    } else {
      toggleBodyScroll(false)
    }

    // document.getElementById('test').scrollTop =0;

  }, [isSmall]);

  // this triggers on resize for deviceWidth + deviceHeight
  useEffect(() => {
    console.log("device size changed (home):", deviceWidth, deviceHeight, isSmall)

    if(deviceWidth > 0 && deviceHeight > 0) {
      console.log("landscape popup status:", isLandscapePopup)
      const isLSM = isLandscapeMobile()
      if(isLandscapePopup == 0 && isLSM) {
        console.log("small landscape detected- show popup")
        setIsLandscapePopup(2)
      } else if(isLandscapePopup == 2 && !isLSM) {
        // if popup already showing but not correct device then hide
        console.log("already showing popup- need to hide when not landscape")
        setIsLandscapePopup(0)

      }
    }
    

  }, [isSmall, deviceWidth, deviceHeight]);


  // listening to custom event from slidesScroller when animation/slide completes
  useEffect(() => {
    // listen to custom events: https://blog.logrocket.com/using-custom-events-react/
    document.addEventListener("onSlideAnimationComplete", onSlidesScrollerSlideChanged);
    //document.addEventListener("onSlideAnimationBegin", onSlidesScrollerSlideBegin);
    
    console.log("added custom event listener")
    return () => {
      // listen to custom events: https://blog.logrocket.com/using-custom-events-react/
      document.removeEventListener("onSlideAnimationComplete", onSlidesScrollerSlideChanged);
      //document.removeEventListener("onSlideAnimationBegin", onSlidesScrollerSlideBegin);
    };
  }, []);


  // listen to the global navigation help flag
  // if we toggle to small/mobile we need to disable body scroll
  useEffect(() => {
    console.log("isHelp changed (home):", isHelp)
    if(isHelp) {
      onHelpOpenEvent(null)
    }
  }, [isHelp]);

  // only apply the greyscale/fade scale animation if not on mobile
  const cnGrayscaleFilters = `${(isSmall) ? '' : 'grayscale transition duration-500 hover:grayscale-0 hover:scale-105 focus:grayscale-0 focus:scale-105'}`;
  const cnNoteSize = `${(isSmall) ? 'basis-96 ' : 'basis-1/4 '+cnGrayscaleFilters}`; //'w-[22rem] sm:w-[12rem] md:w-[14rem] lg:w-[22rem] ';//
  return (
    <React.Fragment>
      <Helmet>
                {/* <meta charSet="utf-8" /> */}
                {/* <title>My Title</title> */}
                {/* <link rel="canonical" href="http://mysite.com/example" /> */}
                <link rel="preload" as="video" href={MEDIA.INTRO.background} />
                <link rel="preload" as="image" href={MEDIA.INTRO.background_poster} />

                <link rel="preload" as="image" href={MEDIA.FIVE.note_choose} />
                <link rel="preload" as="image" href={MEDIA.TEN.note_choose} />
                <link rel="preload" as="image" href={MEDIA.TWENTY.note_choose} />
                <link rel="preload" as="image" href={MEDIA.FIFTY.note_choose} />
                <link rel="preload" as="image" href={MEDIA.HUNDRED.note_choose} />

                <link rel="preload" as="fetch" href={API.INTRO} />
                <link rel="preload" as="image" href={optionsIcon} />
                <link rel="preload" as="image" href={optionsIconHover} />
                <link rel="preload" as="image" href={closeOptionsIcon} />
                <link rel="preload" as="image" href={closeOptionsIconHover} />
                <link rel="preload" as="image" href={pauseIcon} />
                <link rel="preload" as="image" href={pauseIconOff} />
                <link rel="preload" as="image" href={pauseIconHover} />
                <link rel="preload" as="image" href={pauseIconHoverAlt} />
                <link rel="preload" as="image" href={contrastIcon} />
                <link rel="preload" as="image" href={contrastIconOff} />
                <link rel="preload" as="image" href={contrastIconHover} />
                <link rel="preload" as="image" href={contrastIconHoverAlt} />
                <link rel="preload" as="image" href={soundIcon} />
                <link rel="preload" as="image" href={soundIconOff} />
                <link rel="preload" as="image" href={soundIconHover} />
                <link rel="preload" as="image" href={soundIconHoverAlt} />
                <link rel="preload" as="image" href={logoIcon} />
                <link rel="preload" as="image" href={logoIconHover} />


      </Helmet>
      <div className='absolute block top-0 left-0 w-full h-full'>
      {/* main page preloader- needs to preload ALL content including background image */}
      { isPreloading && 
          <div className='absolute h-full w-screen z-30' >
            <Spinner icon={spinnerIcon} text={'Loading intro content...'}/>
            {/* <p className='absolute'>Loading content for {props.note}</p> */}
          </div>
        }

      <div className={ (isPreloading) ? 'invisible' : 'visible' } >
      {
        data != null  ? <>
      <VideoBackgroundFixed url={MEDIA.INTRO.background} poster={MEDIA.INTRO.background_poster} preloadCB={updatePreloadCounter} overlay={isContrast ? MEDIA.INTRO.overlay : null}/>  
      <SlidesScroller id="home" ref={slidesScrollerRef} firstSlide={firstSlideRef} slideCount={4} progressIcons={progressIcons}>
        {/* <div id="scrollWrapper" className="overflow-y-auto overflow-x-hidden w-full h-screen relative"> */}
        <SlideFull id="slide0" index="2" ref={firstSlideRef} className="">
          {customSlideEventIndex == 0 &&
          <div className='max-w-[46rem] pb-[4rem] px-[2rem] md:px-[0rem] lg:px-[0rem] xl:px-[0rem] 2xl:px-[0rem] pr-[2rem] md:pr-[3rem] lg:pr-[3rem] xl:pr-[3rem] 2xl:pr-[3rem] pl-[2rem] p-displayPadSm lg:p-displayPad' >
                {/* px-[2rem] md:px-[0rem] lg:px-[0rem] xl:px-[0rem] 2xl:px-[0rem] */}
                <h1 className="text-4xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold animate-slidexFadeinDelayA">
                {data.title}
                
                
                {/* Exploring the Next Generation of Banknotes       */}
                </h1>
                <p className='font-bold mt-6 text-lg animate-slidexFadeinDelayB'>
                {data.description}
                {/* <Spinner /> */}
                   {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.  */}
                </p>
                {/* <div onClick={() => gotoSlide(2)}>goto prev slide</div> */}
                {/* <Link to="#slide0">
                    <a>Scroll up 
                    <img className="inline ml-2" src={scrollDownIcon} alt="" width={18} height={18} />
                    </a>
                </Link> */}
                
                { !isSmall ?
                <div className="mt-9 font-bold flex flex-row flex-wrap items-center justify-center animate-slidexFadeinDelayC">
                {/* <ButtonTextIcon text="Scroll down" icon={scrollDownIcon} iconSize="18" onClick={() => slidesScrollerRef.current.gotoNextSlideMod()}/> */}
                {/* <Footer onScrollDownClick={() => slidesScrollerRef.current.gotoNextSlideMod()}/> */}
                
                  <ButtonTextIconWhiteHover text="Scroll down" icon={scrollDownIcon} iconAlt="Scroll down" iconSize="20" onClick={() => slidesScrollerRef.current.gotoNextSlideMod()}/>
                  
                
                {/* <WavingFlag
                  flag="https://external-preview.redd.it/QVS6D1FlDcpx7byaow-LyO4GpezIlepIkozbzwqtFOY.png?auto=webp&s=d60d5e9953842259ade3c425c55354f6651029f4"
                  height={200}
                  width={300}
                /> */}
                </div>
                : 
                  <div className="mt-4 font-bold flex flex-row flex-wrap items-center justify-center animate-slidexFadeinDelayC">
                  <p className='font-italic max-w-[18rem]'>Use the arrows on the bottom right to scroll through the site</p>
                  </div>
                }
                
            </div>
            }
        </SlideFull>
        {/* </div> */}

        {/* <div id="slide1" index="3" className="overflow-y-auto overflow-x-hidden w-full h-screen relative"> */}
        <SlideFull id="slide1" index="3" className="!justify-start md:!justify-center lg:!justify-center xl:!justify-center 2xl:!justify-center ">        
          {customSlideEventIndex == 1 ?          
          <div className='max-w-[95rem] pb-20 p-displayPad' >
              {/* <div className={((isPreloading) ? '' : 'animate-slidexFadeinDelayA ')}> */}
                <h1 className={"text-4xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-10 animate-slidexFadeinDelayA "} onClick={() => handleTestEvent()}>
                Choose a banknote
                </h1>
                <div className='flex flex-wrap justify-center gap-x-2 gap-y-2 font-bold animate-slidexFadeinDelayB'>
                  <Link to="/five" className={cnNoteSize} >
                      {/* height={180} width={360}  */}
                      <img className="" src={MEDIA.FIVE.note_choose} alt="$5 Banknote" />
                      <h5 className="text-2xl leading-[3rem]">$5 Banknote</h5>
                  </Link>
                  <Link to="/ten" className={cnNoteSize}>
                    {/* <img className={cnGrayscaleFilters}  src={MEDIA.TEN.note_choose} alt="$10 Banknote"  /> */}
                    <img className=""  src={MEDIA.TEN.note_choose} alt="$10 Banknote"  />
                      <h5 className="text-2xl leading-[3rem]">$10 Banknote</h5>
                  </Link>
                    <Link to="/twenty" className={cnNoteSize}>
                    <img className=""  src={MEDIA.TWENTY.note_choose} alt="$20 Banknote" />
                      <h5 className="text-2xl leading-[3rem]">$20 Banknote</h5>
                  </Link>
                  <Link to="/fifty" className={cnNoteSize}>
                    <img className=""  src={MEDIA.FIFTY.note_choose} alt="$50 Banknote" />
                      <h5 className="text-2xl leading-[3rem]">$50 Banknote</h5>
                  </Link>
                  <Link to="/hundred" className={cnNoteSize}>
                    <img className=""  src={MEDIA.HUNDRED.note_choose} alt="$100 Banknote"  />
                      <h5 className="text-2xl leading-[3rem]">$100 Banknote</h5>
                  </Link>                  
                </div>
                { isSmall ?
                <div className='relative w-full h-[3rem] flex justify-center mb-[3rem]'>
                  <ButtonTextIconWhiteHover text="Background credits" icon={creditsIcon} iconAlt="Background credits" iconSize="24" onClick={onCreditsOpenEvent}/>
                </div>
                :
                <div className='absolute bottom-0 mb-3 right-0 w-full max-w-[300px] h-[3rem] flex justify-end z-50'>
                  <ButtonTextIconWhiteHover text="Background credits" icon={creditsIcon} iconAlt="Background credits" iconSize="24" onClick={onCreditsOpenEvent}/>
                  {/* onClick={props.onCreditsClick} */}
                  <div className="w-[15px]"></div>
                </div>
                }
                
            </div>
            : 
            <div className='absolute h-full w-screen'>
              {/* <Spinner icon={spinnerIcon} /> */}
              {/* preload the main images on slide 0 then remove from dom when loaded: (isPreloading) ? 'invisible' : 'hidden' */}
              <div className={(isPreloading) ? 'invisible' : 'hidden'}>
                <PreloadedImages preloadCB={updatePreloadCounter} images={[MEDIA.FIVE.note_choose,MEDIA.TEN.note_choose,MEDIA.TWENTY.note_choose,MEDIA.FIFTY.note_choose,MEDIA.HUNDRED.note_choose]}></PreloadedImages>

                {/* <Link to="/five" className={cnNoteSize} >
                    <img className={cnGrayscaleFilters} src={MEDIA.FIVE.note_choose} alt="RBA Logo"  onLoad={() => {updatePreloadCounter(MEDIA.FIVE.note_choose)}} />
                    <h5 className="text-2xl leading-[3rem]">$5 Banknote</h5>
                </Link>
                <Link to="/ten" className={cnNoteSize}>
                  <img className={cnGrayscaleFilters}  src={MEDIA.TEN.note_choose} alt="RBA Logo" onLoad={() => {updatePreloadCounter(MEDIA.TEN.note_choose)}} />
                    <h5 className="text-2xl leading-[3rem]">$10 Banknote</h5>
                </Link>
                  <Link to="/twenty" className={cnNoteSize}>
                  <img className={cnGrayscaleFilters}  src={MEDIA.TWENTY.note_choose} alt="RBA Logo" onLoad={() => {updatePreloadCounter(MEDIA.TWENTY.note_choose)}} />
                    <h5 className="text-2xl leading-[3rem]">$20 Banknote</h5>
                </Link>
                <Link to="/fifty" className={cnNoteSize}>
                  <img className={cnGrayscaleFilters}  src={MEDIA.FIFTY.note_choose} alt="RBA Logo" onLoad={() => {updatePreloadCounter(MEDIA.FIFTY.note_choose)}}  />
                    <h5 className="text-2xl leading-[3rem]">$50 Banknote</h5>
                </Link>
                <Link to="/hundred" className={cnNoteSize}>
                  <img className={cnGrayscaleFilters}  src={MEDIA.HUNDRED.note_choose} alt="RBA Logo" onLoad={() => {updatePreloadCounter(MEDIA.HUNDRED.note_choose)}} />
                    <h5 className="text-2xl leading-[3rem]">$100 Banknote</h5>
                </Link>   */}
              </div>
            </div>
            }
            {/* </div> */}

        </SlideFull>
        {/* </div> */}
        
      </SlidesScroller>
      <Footer slideCount={-1} onCreditsClick={onCreditsOpenEvent} onScrollDownClick={() => slidesScrollerRef.current.gotoNextSlideMod()} onScrollUpClick={() => slidesScrollerRef.current.gotoPrevSlideMod()}/>

      
      </> : <div className='absolute h-full w-screen'>
          {/* <Spinner icon={spinnerIcon}/> */}
        </div>
      }
      {/* <Footer slideCount={-1}  /> */}
      


      { isCredits &&
          <ModalOverlay onModalClose={onCreditsCloseEvent} fullscreen={false}> 
              {/* safar ios bug: https://v2.tailwindcss.com/docs/upgrading-to-v2#the-scrolling-touch-and-scrolling-auto-utilities-have-been-removed */}
            
            <div className='my-0 mx-0 px-14 py-14 text-left max-h-full overflow-y-auto scrolling-touch'>
              <h1 className="text-4xl md:text-6xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-6">
                Background credits       
              </h1>
              <h5 className="font-bold text-2xl">{getBackgroundCredits('title', '$5')}</h5>
              <p className='my-6 text-lg'>{getBackgroundCredits('text', '$5')}</p>
              <h5 className="font-bold text-2xl">{getBackgroundCredits('title', '$10')}</h5>
              <p className='my-6 text-lg'>{getBackgroundCredits('text', '$10')}</p>
              <h5 className="font-bold text-2xl">{getBackgroundCredits('title', '$20')}</h5>
              <p className='my-6 text-lg'>{getBackgroundCredits('text', '$20')}</p>
              <h5 className="font-bold text-2xl">{getBackgroundCredits('title', '$50')}</h5>
              <p className='my-6 text-lg'>{getBackgroundCredits('text', '$50')}</p>
              <h5 className="font-bold text-2xl">{getBackgroundCredits('title', '$100')}</h5>
              <p className='my-6 text-lg'>{getBackgroundCredits('text', '$100')}</p>
              <div id="bottomGradient" className="absolute block h-20 w-full px-14 z-10 bottom-0 left-0">
                <div className="h-full w-full bg-gradient-to-t from-rba-gray-options to-rba-gray-options-alpha"></div>
              </div>
            </div>
          </ModalOverlay>
    }
    { isHelp &&
          <ModalOverlay onModalClose={onHelpClosed} fullscreen={false}> 
              {/* safar ios bug: https://v2.tailwindcss.com/docs/upgrading-to-v2#the-scrolling-touch-and-scrolling-auto-utilities-have-been-removed */}
            
            <div className='my-0 mx-0 px-14 py-14 text-left max-h-full overflow-y-auto scrolling-touch'>
              <h1 className="text-4xl md:text-6xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-6">
                {helpData.title}      
              </h1>
              <p className='my-6 text-lg'>{ parse(helpData.description) }</p>
              <div id="bottomGradient" className="absolute block h-20 w-full px-14 z-10 bottom-0 left-0">
                <div className="h-full w-full bg-gradient-to-t from-rba-gray-options to-rba-gray-options-alpha"></div>
              </div>
            </div>

            {/* <div id="bottomGradient" className="fixed block h-14 w-full px-14 z-9 bottom-0 left-0 bg-[#00ff00]"></div> */}
          </ModalOverlay>
    }

    { (isLandscapePopup > 1 && _isMobile === true) && 
      <ModalOverlaySmall onModalClose={onLandscapePopupCloseEvent} fullscreen={false}>
        <div className='flex flex-col my-0 mx-0 px-15 py-14 text-left h-full items-center justify-center '>
          <div className="grow "></div>
          {/* <h1 className="text-4xl md:text-6xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-6"> */}
            {/* Landscape popup        */}
          {/* </h1> */}
          {/* <h5 className="font-bold text-2xl">Dont do that</h5> */}
          <p className='grow-0 text-lg'>This site is best viewed in portrait mode.</p>
          <div className="grow "></div>
        </div>
      </ModalOverlaySmall>
    }
    
    </div>
    </div>

    </React.Fragment>
  )
}
